import React, { useState } from "react";
import './Admin.css';
import RTEditor from '../../utils/RTEditor';
import {saveCodeOfConduct, saveConferenceInfo } from "../../services/ConferenceInformation";
import { Alert } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import ErrorIcon from "@mui/icons-material/Error";

export default function CodeOfConduct({ conferenceInfo, onConferenceInfoUpdate }: { conferenceInfo: any, onConferenceInfoUpdate: () => void }) {
   //Alert
   const [isShowAlert, setShowAlert] = useState(false);
   const [errorMessage, setErrorMessage] = useState(false);

  const handleSave = async (editorContent: string) => {
    try{
      if (conferenceInfo?.CoC !== editorContent) {
        if(conferenceInfo!==undefined){
            conferenceInfo.CoC=editorContent;
            await saveCodeOfConduct(editorContent);
            onConferenceInfoUpdate();
            setShowAlert(true);
          setTimeout(() => {
            setShowAlert(false);
          }, 5000);
        }
      }
    }catch(error){
      setErrorMessage(true);
          setTimeout(() => {
            setShowAlert(false);
          }, 5000);   }
  };
  return (
    <div className="Margin">
      {isShowAlert && (
          <Alert icon={<CheckIcon fontSize="inherit" />} severity="success">
           Code of Conduct successfully submitted.
          </Alert>
        )}
         {errorMessage && (
        <Alert icon={<ErrorIcon fontSize="inherit" />} severity="error">
          Error saving Code of Conduct.
        </Alert>
      )}
      <div className="EditorContainer">
        <RTEditor editorName={"Code Of Conduct"}
          content={conferenceInfo?.CoC}
          saveContent={handleSave} />
      </div>
    </div>
  );
}
